import moment from "moment";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import { env } from "../../env";
import axios from "axios";

const AssetFormPopUpComponent = ({defaultProductImage, sendModalCloseDataFromChild, currentAsset, statusList, conditionList}) => {
    const { t } = useTranslation();

    const [showStatus, setShowStatus] = useState(false);
    const [showCondition, setShowCondition] = useState(false);
    const [isButtonLoading, setIsButtonLoading] = useState(false);

    const [statusName, setStatusName] = useState(currentAsset.Title);
    const [statusId, setStatusId] = useState(currentAsset.Status_id);
    const [conditionName, setConditionName] = useState(currentAsset.conditionTitle);
    const [conditionId, setConditionId] = useState(currentAsset.Condition_id);
    const [usage, setUsage] = useState(currentAsset.Usage);
   
    const hangleModalClose = (e) => {
        e.preventDefault();
        sendModalCloseDataFromChild("normal");
    };
    const handleShowStatus = (e) => {
        e.preventDefault();
        setShowStatus(!showStatus);
        setShowCondition(false);
    };
    const handleShowCondition = (e) => {
        e.preventDefault();
        setShowCondition(!showCondition);
        setShowStatus(false);
    };
    const handleStatus = (e, value) => {
        e.preventDefault();
        setShowStatus(!showStatus);
        setStatusName(value.Title);
        setStatusId(value.Id);
    };
    const handleCondition = (e, value) => {
        e.preventDefault();
        setShowCondition(!showCondition);
        setConditionName(value.Title);
        setConditionId(value.Id);
    };
    const handleUsage = (e) => {
        setUsage(e.target.value);
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        if((statusId && conditionId && usage)) {
            Swal.fire({
                title: `${ t("are you sure")}?`,
                text: `${ t("you want to update asset data")}!`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: `${ t("yes")}!`,
                cancelButtonText: `${ t("cancel")}!`
            }).then((result) => {
                if (result.isConfirmed) {   
                    setIsButtonLoading(true);     
                    const baseUrl = env.REACT_APP_API_URL;
                    const token = localStorage.getItem('token');
                    const requestData = {
                        "id": currentAsset.Id,
                        "statusid": statusId,
                        "conditionid": conditionId,
                        "usage": usage
                    }
                    axios.post(baseUrl+"/api/Assets/UpdateStatus", requestData, {
                        headers : {
                            "Accept" : "Application/json",
                            "Content-Type" : "Application/json",
                            "Authorization" : `Bearer ${token}`
                        }
                    }).then((response) => {
                        if(response.data.success === "1") {
                            sendModalCloseDataFromChild("updated");
                            Swal.fire({
                                title: `${ t("asset updated")}!`,
                                icon: "success",
                            });
                        }
                        setIsButtonLoading(false);
                    }).catch((error) => {
                        console.log(error);
                        setIsButtonLoading(false);
                        if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                            localStorage.removeItem("token");
                            localStorage.removeItem("userInfo");
                            window.location.reload();
                        }
                    });
                }
            });
        }
    };
    
    return (
        <>
            {Object.keys(currentAsset).length 
                ?
                    <form onSubmit={(e) => handleSubmit(e)}>
                        <div className="space-y-1 sm:space-y-2">
                            {/* data */}
                            <div className="rounded-xl bg-white flex space-x-2 p-2 cursor-pointer border border-background-normal">
                                <img className="w-14 h-14 sm:w-16 sm:h-16 rounded-lg border border-background-normal" src={defaultProductImage} alt="product-img" />
                                <div className="flex flex-col justify-between w-full">
                                    <h1 className="font-semibold text-xs sm:text-base capitalize">{currentAsset.Asset_Descr}</h1>
                                    <div className="flex justify-between space-x-1 sm:space-x-2 items-center w-fit">
                                        <div className="capitalize text-[10px] sm:text-xs text-light-700">{ t('asset code')}<span className="font-medium text-black">: {currentAsset.AssetCode}</span></div>
                                        <div className="border h-3 border-light-400"></div>
                                        <div className="capitalize text-[10px] sm:text-xs text-light-700">{ t('since')}<span className="font-medium text-black">: {moment(currentAsset.Manufactured_date).format('DD/MM/YYYY')}</span></div>
                                    </div>
                                    <div className="flex justify-between items-center w-full">
                                        <div className="capitalize text-[10px] sm:text-xs text-light-700">{ t('s.no.')}<span className="font-medium text-black">: {currentAsset.Serial_no}</span></div>
                                        <div className={((currentAsset.Status_id == 1) ? 'bg-green-normal px-1 py-0.5' : ((currentAsset.Status_id == 2) ? 'bg-red-normal px-1 py-0.5' : ((currentAsset.Status_id == 3) ? 'bg-yellow-normal1 px-1 py-0.5' : "p-0"))) + " capitalize text-white bg-green-normal rounded-md text-[10px] sm:text-xs"}>
                                            {(currentAsset.Status_id == 1) ? t('active') : ((currentAsset.Status_id == 2) ? t('inactive') : ((currentAsset.Status_id == 3) ? t('maintanance') : null))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* description */}
                            <div className="rounded-xl bg-white border border-background-normal p-2 space-y-1">
                                <h1 className="font-semibold capitalize text-xs sm:text-sm">{ t('description')}</h1>
                                <div className="text-light-400 text-[10px] sm:text-xs">{currentAsset.Comments}</div>
                            </div>
                            {/* assets */}
                            <div className="rounded-xl bg-white border border-background-normal p-2">
                                <h1 className="font-semibold capitalize text-xs sm:text-sm">{ t('asset information')}</h1>
                                <div className="divide-y divide-dashed">
                                    <div className="flex justify-between items-center py-1 sm:py-1.5">
                                        <div className="text-light-400 text-[10px] sm:text-xs font-normal capitalize"> { t('date of issue')}</div>
                                        <div className="font-medium text-[10px] sm:text-xs break-words sm:w-auto">{moment(currentAsset.Manufactured_date).format('DD/MM/YYYY')}</div>
                                    </div>
                                    <div className="flex justify-between items-center py-1 sm:py-1.5">
                                        <div className="text-light-400 text-[10px] sm:text-xs font-normal capitalize"> { t('service expiry date')}</div>
                                        <div className="font-medium text-[10px] sm:text-xs break-words sm:w-auto">{moment(currentAsset.WarrantyExpireDate).format('DD/MM/YYYY')}</div>
                                    </div>
                                    <div className="flex justify-between items-center py-1 sm:py-1.5">
                                        <div className="text-light-400 text-[10px] sm:text-xs font-normal capitalize"> { t('model')}</div>
                                        <div className="font-medium text-[10px] sm:text-xs break-words sm:w-auto">{currentAsset.Model}</div>
                                    </div>
                                    <div className="flex justify-between items-center pt-1.5">
                                        <div className="text-light-400 text-[10px] sm:text-xs font-normal capitalize"> { t('supplier/manufacturer')}</div>
                                        <div className="font-medium text-[10px] sm:text-xs break-words sm:w-auto">{currentAsset.Supplier}</div>
                                    </div>
                                </div>
                            </div>
                            {/* status */}
                            <div className="rounded-xl bg-white border border-background-normal p-2">
                                <h1 className="font-semibold capitalize text-xs sm:text-sm">{ t('status & usage')}</h1>
                                <div className="divide-y divide-dashed">
                                    <div className="flex justify-between items-center py-1 sm:py-1.5">
                                        <div className="text-light-400 text-[10px] sm:text-xs font-normal capitalize"> { t('status')}</div>
                                        <div className="relative inline-block">
                                            <button onClick={(e) => handleShowStatus(e)} type="button" className="bg-background-normal text-gray-dark w-full justify-between font-normal py-1 px-2 rounded-md inline-flex items-center text-[10px] sm:text-xs space-x-3">
                                                <span className={(statusName) ? "text-black capitalize " : "text-gray-dark capitalize " + " mr-1"}>{statusName ? statusName : 'select'}</span>
                                                <img src="../../../assets/icons/select-down.svg" alt="select-down" />
                                            </button>
                                            {
                                                showStatus
                                                ? 
                                                    <ul className="absolute z-30 bg-white shadow-md top-6 right-0 rounded-md text-[10px] sm:text-xs w-max">
                                                        {statusList.map((status, index) => (
                                                            <li key={`status`+index} onClick={(e) => handleStatus((e), status)}  className="bg-white hover:bg-action-hover py-2 px-4 block whitespace-no-wrap cursor-pointer capitalize">{status.Title}</li>
                                                        ))}
                                                    </ul>                            
                                                : null
                                            }
                                        </div>
                                    </div>
                                    <div className="flex justify-between items-center py-1 sm:py-1.5">
                                        <div className="text-light-400 text-[10px] sm:text-xs font-normal capitalize"> { t('condition')}</div>
                                        <div className="relative inline-block">
                                            <button onClick={(e) => handleShowCondition(e)} type="button" className="bg-background-normal text-gray-dark w-full justify-between font-normal py-1 px-2 rounded-md inline-flex items-center text-[10px] sm:text-xs space-x-3">
                                                <span className={(conditionName) ? "text-black capitalize " : "text-gray-dark capitalize " + " mr-1"}>{conditionName ? conditionName : 'select'}</span>
                                                <img src="../../../assets/icons/select-down.svg" alt="select-down" />
                                            </button>
                                            {
                                                showCondition
                                                ? 
                                                    <ul className="absolute z-30 bg-white shadow-md top-6 right-0 rounded-md text-[10px] sm:text-xs w-max">
                                                        {conditionList.map((condition, index) => (
                                                            <li key={`condition`+index} onClick={(e) => handleCondition((e), condition)}  className="bg-white hover:bg-action-hover py-2 px-4 block whitespace-no-wrap cursor-pointer capitalize">{condition.Title}</li>
                                                        ))}
                                                    </ul>  
                                                : null
                                            }
                                        </div>
                                    </div>
                                    <div className="flex justify-between items-center pt-1.5">
                                        <div className="text-light-400 text-[10px] sm:text-xs font-normal capitalize"> { t('usage (no.of hours in a day)')}</div>
                                        <div className="relative text-right inline-block w-32">
                                            <input type="text" className="w-32 text-right rounded-md bg-action-hover border border-background-normal p-1 focus:outline-none" name="usage" value={usage} onChange={(e) => handleUsage(e)} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* form button */}
                            <div className="hidden sm:flex justify-end items-center space-x-4">
                                <button onClick={(e) => hangleModalClose(e)} type="button" className="text-center px-4 font-medium py-2 text-light-400 bg-white border border-light-400 rounded-lg tracking-wide capitalize text-sm">{ t('close') }</button>
                                {!isButtonLoading 
                                    ? 
                                        <button type={(statusId && conditionId && usage) ? "submit" : "button"} className={((statusId && conditionId && usage) ? "text-white bg-blue-normal border-blue-normal" : "text-white border-blue-disable cursor-not-allowed bg-blue-disable" ) + " text-center px-4 text-sm font-medium py-2 border rounded-lg tracking-wide capitalize"}>{ t('update details') }</button>
                                    :
                                        <button type="button" className="text-white bg-blue-normal border-blue-normal text-center px-4 text-sm font-medium py-2 border rounded-lg tracking-wide capitalize cursor-wait">{t('Please wait, in-progress')}</button>
                                }
                                
                            </div>
                        </div>
                        {isButtonLoading}
                        <div className="fixed bottom-0 sm:hidden flex items-center bg-white rounded-t-xl border border-background-normal justify-between p-2 shadow-md w-screen right-0">
                            {!isButtonLoading 
                                ? 
                                    <button type={(statusId && conditionId && usage) ? "submit" : "button"} className={((statusId && (conditionId != 0) && usage) ? "text-white bg-blue-normal border-blue-normal" : "text-white border-blue-disable cursor-not-allowed bg-blue-disable" ) + " text-center px-4 text-xs font-medium py-2 border rounded-lg tracking-wide capitalize w-full"}>{ t('update details') }</button>
                                :
                                    <button type="button" className="text-white bg-blue-normal border-blue-normal text-center px-4 text-xs font-medium py-2 border rounded-lg tracking-wide capitalize w-full cursor-wait">{t('Please wait, in-progress')}</button>
                            }
                        </div>
                    </form>
                :
                    <div className="p-4 text-center font-bold text-xs sm:text-xl rounded-lg capitalize">
                    { t('no records available')}
                    </div>
            }
        </>
    )
}

export default AssetFormPopUpComponent;